import { useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

import { authEvents } from '@/core/lib/auth-events'
import { notify } from '@/core/lib/ui-bus'
import { signOut } from '@/core/utils/auth-utils'

// HTTP katmanını (api.ts) router'a köprüler: oturum-bitti → çıkış + girişe yönlendir;
// yetkisiz → forbidden sayfasına yönlendir. Root layout içinde bir kez mount edilir.
const AuthEventsBinder = () => {
  const router = useRouter()

  useEffect(() => {
    const offSignedOut = authEvents.on('signed-out', ({ reason }) => {
      void signOut().then(() => {
        // reason verildiyse PROAKTİF çıkış (ör. şifre değişimi) → bağlam mesajı; yoksa pasif
        // 401 (oturum beklenmedik bitti) → varsayılan mesaj.
        notify.warning(
          reason ?? 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.'
        )
        void router.navigate({ to: '/' })
      })
    })
    const offForbidden = authEvents.on('forbidden', () => {
      void router.navigate({ to: '/app/forbidden' })
    })
    return () => {
      offSignedOut()
      offForbidden()
    }
  }, [router])

  return null
}

export default AuthEventsBinder
